"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var inertia_1 = require("@inertiajs/inertia");
var ej2_react_grids_1 = require("@syncfusion/ej2-react-grids");
var page_1 = require("@syncfusion/ej2-grids/src/grid/actions/page");
require("@syncfusion/ej2/tailwind.css");
require("@syncfusion/ej2-base/styles/tailwind.css");
require("@syncfusion/ej2-react-grids/styles/tailwind.css");
var formatters_1 = require("@/utils/formatters");
var POLL_INTERVAL_MS = 5000;
var dateTimeFormatter = new Intl.DateTimeFormat('en-AU', {
    dateStyle: 'medium',
    timeStyle: 'short',
});
var dateFormatter = new Intl.DateTimeFormat('en-AU', { dateStyle: 'medium' });
var currencyFormatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
});
var formatDateTime = function (value) {
    if (!value) {
        return '—';
    }
    var parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? value : dateTimeFormatter.format(parsed);
};
var formatDate = function (value) {
    if (!value) {
        return '—';
    }
    var parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? value : dateFormatter.format(parsed);
};
var formatMoney = function (value) {
    return typeof value === 'number' ? currencyFormatter.format(value) : '—';
};
var statusBadge = function (status, inProgress, stalled) {
    if (inProgress) {
        return 'bg-amber-100 text-amber-700';
    }
    if (stalled) {
        return 'bg-orange-100 text-orange-700';
    }
    var normalized = status === null || status === void 0 ? void 0 : status.toLowerCase();
    if (normalized === 'completed' || normalized === 'success') {
        return 'bg-green-100 text-green-700';
    }
    if (normalized === 'failed') {
        return 'bg-red-100 text-red-700';
    }
    return 'bg-slate-100 text-slate-600';
};
/** Payments belonging to one invoice, shown when its row is expanded. */
var paymentsTemplate = function (invoice) {
    var _a;
    if (!((_a = invoice.payments) === null || _a === void 0 ? void 0 : _a.length)) {
        return (react_1.default.createElement("p", { className: "px-4 py-3 text-sm text-slate-500" }, "No payment records cached for this invoice."));
    }
    return (react_1.default.createElement("table", { className: "w-full text-sm" },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", { className: "text-left text-xs uppercase tracking-wide text-slate-400" },
                react_1.default.createElement("th", { className: "px-4 py-2" }, "Paid"),
                react_1.default.createElement("th", { className: "px-4 py-2 text-right" }, "Amount"),
                react_1.default.createElement("th", { className: "px-4 py-2" }, "Reference"),
                react_1.default.createElement("th", { className: "px-4 py-2" }, "Account"))),
        react_1.default.createElement("tbody", null, invoice.payments.map(function (payment) {
            var _a, _b;
            return (react_1.default.createElement("tr", { key: payment.payment_guid, className: "border-t border-slate-100" },
                react_1.default.createElement("td", { className: "px-4 py-2" }, formatDate(payment.date)),
                react_1.default.createElement("td", { className: "px-4 py-2 text-right" }, formatMoney(payment.amount)),
                react_1.default.createElement("td", { className: "px-4 py-2" }, (_a = payment.reference) !== null && _a !== void 0 ? _a : '—'),
                react_1.default.createElement("td", { className: "px-4 py-2" }, (_b = payment.account_name) !== null && _b !== void 0 ? _b : '—')));
        }))));
};
function XeroPaidInvoices(_a) {
    var _this = this;
    var _b, _c, _d;
    var invoices = _a.invoices, rowLimit = _a.rowLimit, canForceSync = _a.canForceSync;
    var route = (0, useRoute_1.default)();
    var _e = (0, react_1.useState)(null), progress = _e[0], setProgress = _e[1];
    var _f = (0, react_1.useState)(false), triggering = _f[0], setTriggering = _f[1];
    var _g = (0, react_1.useState)(null), error = _g[0], setError = _g[1];
    var timerRef = (0, react_1.useRef)(null);
    var loadProgress = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var response, _a, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(route('xero.sync.status'), {
                            headers: { Accept: 'application/json' },
                            credentials: 'same-origin',
                        })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) {
                        return [2 /*return*/];
                    }
                    _a = setProgress;
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.apply(void 0, [_b.sent()]);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [route]);
    (0, react_1.useEffect)(function () {
        loadProgress();
    }, [loadProgress]);
    // Poll only while a run is actually in flight.
    (0, react_1.useEffect)(function () {
        if (!(progress === null || progress === void 0 ? void 0 : progress.in_progress)) {
            if (timerRef.current) {
                window.clearInterval(timerRef.current);
                timerRef.current = null;
            }
            return;
        }
        timerRef.current = window.setInterval(loadProgress, POLL_INTERVAL_MS);
        return function () {
            if (timerRef.current) {
                window.clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [progress === null || progress === void 0 ? void 0 : progress.in_progress, loadProgress]);
    var forceSync = function () {
        setTriggering(true);
        setError(null);
        inertia_1.Inertia.post(route('xero.sync.trigger'), {}, {
            preserveScroll: true,
            onError: function () { return setError('Could not start the sync. It may already be running.'); },
            onFinish: function () {
                setTriggering(false);
                loadProgress();
            },
        });
    };
    var inProgress = (_b = progress === null || progress === void 0 ? void 0 : progress.in_progress) !== null && _b !== void 0 ? _b : false;
    var stalled = (_c = progress === null || progress === void 0 ? void 0 : progress.stalled) !== null && _c !== void 0 ? _c : false;
    return (react_1.default.createElement(AppLayout_1.default, { title: "Paid Invoices", renderHeader: function () { return (react_1.default.createElement("div", { className: "flex flex-col gap-1" },
            react_1.default.createElement("p", { className: "text-xs uppercase tracking-[0.3em] text-green-500" }, "Xero"),
            react_1.default.createElement("h2", { className: "text-2xl font-semibold text-gray-900" }, "Paid Invoices"),
            react_1.default.createElement("p", { className: "text-sm text-gray-500" }, "Which invoices have been paid, and when each payment landed"))); } },
        react_1.default.createElement("div", { className: "py-10" },
            react_1.default.createElement("div", { className: "mx-auto max-w-7xl space-y-6 px-4 sm:px-6 lg:px-8" },
                react_1.default.createElement("section", { className: "rounded-2xl border border-slate-100 bg-white p-6 shadow-sm" },
                    react_1.default.createElement("div", { className: "flex flex-wrap items-start justify-between gap-4" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("p", { className: "text-xs uppercase tracking-wide text-slate-400" }, "Xero Sync"),
                            react_1.default.createElement("p", { className: "mt-2 text-lg font-semibold text-slate-900" }, (progress === null || progress === void 0 ? void 0 : progress.run) ? 'Last sync run' : 'No sync run yet'),
                            (progress === null || progress === void 0 ? void 0 : progress.run) ? (react_1.default.createElement("div", { className: "mt-3 flex flex-wrap items-center gap-3 text-sm text-slate-600" },
                                react_1.default.createElement("span", { className: "inline-flex rounded-full px-3 py-1 text-xs font-semibold ".concat(statusBadge(progress.run.status, inProgress, stalled)) }, inProgress
                                    ? 'Running'
                                    : stalled
                                        ? 'Stalled'
                                        : (0, formatters_1.humanizeStatus)((_d = progress.run.status) !== null && _d !== void 0 ? _d : '')),
                                react_1.default.createElement("span", null,
                                    "Started: ",
                                    formatDateTime(progress.run.started_at)),
                                progress.run.finished_at ? (react_1.default.createElement("span", null,
                                    "Finished: ",
                                    formatDateTime(progress.run.finished_at))) : null,
                                progress.total > 0 ? (react_1.default.createElement("span", null,
                                    progress.processed,
                                    " of ",
                                    progress.total,
                                    " contacts")) : null,
                                progress.failed > 0 ? (react_1.default.createElement("span", { className: "text-red-600" },
                                    progress.failed,
                                    " failed")) : null,
                                stalled ? (react_1.default.createElement("span", { className: "text-orange-600" },
                                    progress.pending,
                                    " never started \u2014 run it again to finish them")) : null)) : null),
                        canForceSync ? (react_1.default.createElement("button", { type: "button", onClick: forceSync, disabled: triggering || inProgress, className: "inline-flex items-center rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-green-700 disabled:cursor-not-allowed disabled:bg-slate-300" }, inProgress ? 'Sync running…' : triggering ? 'Starting…' : 'Force Xero sync')) : null),
                    error ? react_1.default.createElement("p", { className: "mt-4 text-sm text-red-600" }, error) : null),
                react_1.default.createElement("section", { className: "rounded-2xl border border-slate-100 bg-white p-6 shadow-sm" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("p", { className: "text-xs uppercase tracking-wide text-slate-400" }, "Paid Invoices"),
                        react_1.default.createElement("p", { className: "mt-2 text-lg font-semibold text-slate-900" },
                            "Latest ",
                            rowLimit,
                            " fully paid invoices"),
                        react_1.default.createElement("p", { className: "mt-1 text-sm text-slate-500" }, "Expand a row to see the individual payments against that invoice.")),
                    react_1.default.createElement("div", { className: "mt-4" },
                        react_1.default.createElement(ej2_react_grids_1.GridComponent, { id: "xero-paid-invoices-grid", dataSource: invoices, toolbar: ['Search'], pageSettings: { pageSize: 25 }, allowPaging: true, allowSorting: true, allowFiltering: true, allowTextWrap: true, detailTemplate: paymentsTemplate, sortSettings: {
                                columns: [{ field: 'fully_paid_on', direction: 'Descending' }],
                            } },
                            react_1.default.createElement(ej2_react_grids_1.ColumnsDirective, null,
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "fully_paid_on", headerText: "Fully Paid", width: "160", valueAccessor: function (_field, data) { var _a; return formatDateTime((_a = data === null || data === void 0 ? void 0 : data.fully_paid_on) !== null && _a !== void 0 ? _a : null); } }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "contact_name", headerText: "Contact", width: "200" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "invoice_number", headerText: "Invoice", width: "130" }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "type", headerText: "Type", width: "110", valueAccessor: function (_field, data) { var _a; return (data === null || data === void 0 ? void 0 : data.type) === 'ACCREC' ? 'Sale' : ((_a = data === null || data === void 0 ? void 0 : data.type) !== null && _a !== void 0 ? _a : 'Unknown'); } }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "invoice_date", headerText: "Invoice Date", width: "140", valueAccessor: function (_field, data) { var _a; return formatDate((_a = data === null || data === void 0 ? void 0 : data.invoice_date) !== null && _a !== void 0 ? _a : null); } }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "total", headerText: "Total", width: "120", textAlign: "Right", valueAccessor: function (_field, data) { var _a; return formatMoney((_a = data === null || data === void 0 ? void 0 : data.total) !== null && _a !== void 0 ? _a : null); } }),
                                react_1.default.createElement(ej2_react_grids_1.ColumnDirective, { field: "payment_count", headerText: "Payments", width: "110", textAlign: "Right" })),
                            react_1.default.createElement(ej2_react_grids_1.Inject, { services: [page_1.Page, ej2_react_grids_1.Toolbar, ej2_react_grids_1.Sort, ej2_react_grids_1.Filter, ej2_react_grids_1.DetailRow] }))))))));
}
exports.default = XeroPaidInvoices;
